import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../constants/z_index';
import { args } from 'navigation-components/common/args';
import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../capabilities';
import { getPortalId } from '../../common/utils';
import { GROWTH_UPGRADE_BUTTON_COMPONENT } from '../constants';
export const growthUpgradeButtonComponentDef = defineComponent(GROWTH_UPGRADE_BUTTON_COMPONENT, {
  name: GROWTH_UPGRADE_BUTTON_COMPONENT,
  path: `growth-navigation-embed/${getPortalId()}/embed`,
  capabilities: [capabilities.NAVIGATE_TO_CAP.getName(), capabilities.RESTYLE_CAP.getName()],
  enableHubless: false,
  initiallyOpen: false,
  iframeProps: {
    style: {
      position: 'absolute',
      top: 'var(--global-nav-height)',
      zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT
    }
  },
  initialProps: {
    isSandboxTest: false
  },
  propsSchema: {
    isSandboxTest: args.bool()
  },
  renderTo: () => document.querySelector('#growth-upgrade-button-render-to')
});